import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import timeline from "highcharts/modules/timeline";
import ReactDOM from "react-dom";

timeline(Highcharts);

function NtnEquipementStatesTimeLine(props) {
  let row = props.data.row;
  const options = {
    chart: {
      type: "timeline",
      events: {
        render: function () {
          let collection = document.getElementsByClassName(
            "highcharts-data-label-box"
          );

          for (let key of collection) {
            console.log(key);
            let img = document.createElement("img");
            //img.style = "width : 20px;height: 20px";
            img.width = 20;
            img.height = 20;
            img.src =
              "https://st3.depositphotos.com/3557671/12796/v/950/depositphotos_127964236-stock-illustration-cargo-ship-icon-in-black.jpg";
            key.append(img);
          }

          /*
          this.axes[0].chart.xAxis[0].series[0].points.forEach((item) => {
            // ReactDOM.findDOMNode(item.graphic.element).parentNode
            let img = document.createElement("img");
            img.src =
              "http://e7.pngegg.com/pngimages/582/928/png-clipart-water-transportation-ship-computer-icons-ship-warehouse-transport-thumbnail.png";
            ReactDOM.findDOMNode(
              item.graphic.element.parentNode.parentNode
            ).appendChild(img);
            console.log(
              item.graphic.element.parentNode.getElementsByClassName(
                "highcharts-data-label-box"
              )
            );
        */
          //highcharts-label-box highcharts-data-label-box
        },
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    title: {
      text: "Etats du conteneur",
    },
    subtitle: {
      text: "liste des etats du conteneur",
    },
    height: 50,
    credits: {
      enabled: false,
    },
    series: [
      {
        dataLabels: {
          connectorColor: "silver",
          alternate: false,
          connectorWidth: 5,
          distance: -50,
        },

        data: [
          {
            name: "Entrée au port ",
            label: row.portcall?.list[0]?.aTA?.substring(0, 16),
            description: "ce conteneur est entré au port le  ",
            color: "#97BAEC",
          },
          {
            name: "Déchargement",
            label: row.dischargedDateTime?.substring(0, 16),
            description: "ce conteneur est déchargé le ",
            color: "#6987D5",
          },
          {
            name: "Main levée",
            label: row.customsClearanceDateTime?.substring(0, 16),
            description: "la date de la main levée  est  ",
            color: "#445BC1",
          },
          {
            name: "Sortie du terminal",
            label: row.gateOutDateTime?.substring(0, 16),
            description: "ce conteneur est sortie du terminal le ",
            color: "#1E35A9FF",
          },
          {
            name: 'Sortie du port <img src="entreePort.JPG"/>',
            label: row.gateOutDateTime?.substring(0, 16),
            description: "ce conteneur est sortie du terminal le ",
            color: "#323f7a",
          },
        ],
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}

export default NtnEquipementStatesTimeLine;
